module.exports = __webpack_public_path__ + "img/20220223_155914.8ace1003.jpg";